import { render } from "./HivePhotoSliderHeadless.vue?vue&type=template&id=0ab52476&scoped=true"
import script from "./HivePhotoSliderHeadless.vue?vue&type=script&lang=js"
export * from "./HivePhotoSliderHeadless.vue?vue&type=script&lang=js"

import "./HivePhotoSliderHeadless.vue?vue&type=style&index=0&id=0ab52476&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0ab52476"

export default script